import { ReactElement } from 'react';
import { colors } from '../../colors';
import { getProfitColor } from '../../helpers/colors';
import { formatPercentage } from '../../helpers/NumberFormatter';

interface Props {
  circleLabel: number | string;
  circleColor: string;
  circleSize?: number;
  date?: string;
  currentProfit?: number;
  currentPriceChange?: number;
  content: ReactElement;
  contentWidth?: string;
}

const TransactionItem = ({
  circleLabel,
  circleColor,
  circleSize = 100,
  date,
  currentProfit,
  currentPriceChange,
  content,
  contentWidth = '100%',
}: Props) => {
  const lineColor = colors.gray;

  const borderWidth = 3;
  const circleWidth = `${circleSize}px`;
  const circleRadius = `${circleSize / 2}px`;

  return (
    <div
      style={{
        width: '100%',
        display: 'grid',
        gridTemplateColumns: `${circleWidth} 1fr`,
        gridTemplateRows: `${circleRadius} ${circleRadius} 1fr ${circleWidth}`,
        marginLeft: (100 - circleSize) / 2,
      }}
    >
      {/** CIRCLE */}
      <div
        style={{
          gridColumn: '1 / 2',
          gridRow: '1 / 3',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            width: circleSize,
            height: circleSize - borderWidth * 2,
            borderRadius: '100%',
            border: `${borderWidth}px ${circleColor} solid`,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: colors.white,
            fontWeight: 'bold',
            backgroundColor: colors.black,
            fontSize:
              40 *
              (circleSize / 100) *
              (circleLabel.toString().length === 1 ? 1 : 0.8),
            zIndex: 10,
          }}
        >
          {circleLabel}
        </div>
      </div>
      <div
        style={{
          gridColumn: '2 / 3',
          gridRow: '2 / 4',
          display: 'flex',
          alignItems: 'center',
          marginLeft: -1,
        }}
      >
        <div
          style={{
            height: borderWidth,
            width: circleSize / 2,
            backgroundColor: lineColor,
          }}
        ></div>
        {/** CONTENT CONTAINER */}
        <div
          style={{
            height: '100%',
            border: `${borderWidth}px ${lineColor} solid`,
            borderRadius: 20,
            marginRight: 50,
            position: 'relative',
          }}
        >
          {/** CONTENT */}
          <div style={{ flex: 1 }}>{content}</div>
          {/** DATE */}
          <div
            style={{
              position: 'absolute',
              left: 16,
              top: -24,
              color: colors.gray,
              fontSize: 14,
            }}
          >
            <span>{date}</span>
          </div>
          {/** CURRENT PROFIT */}
          {!!currentProfit && !!currentPriceChange && (
            <div
              style={{
                position: 'absolute',
                right: 16,
                top: -24,
                color: colors.gray,
                fontSize: 14,
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <span>Current Profit:</span>
              <span
                style={{
                  color: getProfitColor(currentProfit || 0),
                  marginLeft: 4,
                }}
              >
                {formatPercentage(currentProfit || 0)}
              </span>
              <span style={{ marginLeft: 12 }}>Current Price Change:</span>
              <span
                style={{
                  color: getProfitColor(currentProfit || 0),
                  marginLeft: 4,
                }}
              >
                {formatPercentage(currentPriceChange || 0)}
              </span>
            </div>
          )}
        </div>
      </div>
      <div
        style={{
          gridColumn: '1 / 2',
          gridRow: '3 / 4',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            height: '100%',
            width: borderWidth,
            backgroundColor: lineColor,
          }}
        ></div>
      </div>
      <div
        style={{
          gridColumn: '1 / 2',
          gridRow: '3 / 4',
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
        }}
      >
        {/** CONNNECTOR */}
        <div
          style={{
            height: 20,
            width: 50 - borderWidth / 2,
            marginTop: -(circleSize / 2) - 20,
            borderBottom: `${borderWidth}px ${lineColor} solid`,
            borderLeft: `${borderWidth}px ${lineColor} solid`,
            borderBottomLeftRadius: 20,
            marginLeft: 100 - circleSize + borderWidth + 0.5,
          }}
        ></div>
      </div>
      <div
        style={{
          gridColumn: '1 / 2',
          gridRow: '4 / 5',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            height: '100%',
            width: borderWidth,
            backgroundColor: lineColor,
          }}
        ></div>
      </div>
    </div>
  );
};

export default TransactionItem;
